import { useState } from "preact/hooks";
import { Modal } from "./Modal";
import { idx, flash } from "../../store";
import { settings } from "../../lib/state";
import { emailTemplate, mailto, type Role } from "../../lib/email";
import { teachersOf, Email } from "../CourseView";

export function ContactsDialog({ ids, onClose }: { ids: string[]; onClose: () => void }) {
  const I = idx.value!;
  const cs = ids.map((id) => I.courses.get(id)!).filter(Boolean);
  const [inferred, setInferred] = useState(false);
  const st = settings.value;
  const upd = (p: Partial<typeof st>) => (settings.value = { ...st, ...p });
  const tpl = emailTemplate(cs, st.lang, st.role as Role, st.myName, st.myIntro);
  const emailsOf = (id: string) => [...new Set(teachersOf(I.courses.get(id)!).filter((l) => l.email && (inferred || l.email_verified !== false)).map((l) => l.email!))];
  const all = [...new Set(cs.flatMap((c) => emailsOf(c.id)))];
  return (
    <Modal title="Nastavnici i emailovi" onClose={onClose} wide>
      <div class="formrow">
        <label>Šablon<select class="field" value={st.lang} onChange={(e) => upd({ lang: (e.target as HTMLSelectElement).value as "bs" | "en" })}><option value="bs">Bosanski</option><option value="en">English</option></select></label>
        <label>Uloga<select class="field" value={st.role} onChange={(e) => upd({ role: (e.target as HTMLSelectElement).value as Role })}><option value="auditor">slobodni slušalac</option><option value="student">student</option><option value="guest">gost</option></select></label>
        <label>Ime<input class="field" value={st.myName} onInput={(e) => upd({ myName: (e.target as HTMLInputElement).value })} placeholder="za potpis" /></label>
        <label class="check" style="flex-direction:row;align-items:center;gap:.3rem;font:13px var(--body)"><input type="checkbox" checked={inferred} onChange={(e) => setInferred((e.target as HTMLInputElement).checked)} /> uključi pretpostavljene adrese</label>
        <button class="btn ghost sm" onClick={() => { navigator.clipboard.writeText(all.join(", ")); flash(`Kopirano ${all.length} adresa`); }}>kopiraj sve ({all.length})</button>
      </div>
      <label style="display:grid;gap:.2rem;font:600 11px var(--mono);color:var(--ink-3)">Nekoliko rečenica o sebi (opcionalno)
        <textarea style="min-height:70px" value={st.myIntro} onInput={(e) => upd({ myIntro: (e.target as HTMLTextAreaElement).value })} placeholder="npr. ko ste i zašto vas predmet zanima" />
      </label>
      {cs.map((c) => {
        const ems = emailsOf(c.id);
        return (
          <div key={c.id}>
            <div class="contact-course">{c.name} <span class="note">{c.fac}</span>
              {ems.length > 0 && <a class="btn ghost sm" style="margin-left:.5rem;text-decoration:none" href={mailto(ems, emailTemplate([c], st.lang, st.role as Role, st.myName, st.myIntro))}>email svima ({ems.length})</a>}
            </div>
            <div class="people">{teachersOf(c).map((l) => <div class="person" key={l.name}><div>{l.name}<span class="role">{l.role || ""}</span></div><Email l={l} /></div>)}</div>
          </div>
        );
      })}
      <h5 style="font:600 11px var(--mono);letter-spacing:.14em;text-transform:uppercase;color:var(--ink-3);margin:1.2rem 0 .4rem">Šablon</h5>
      <textarea readOnly value={`Subject: ${tpl.subject}\n\n${tpl.body}`} />
      <div class="row"><button class="btn" onClick={() => { navigator.clipboard.writeText(`${tpl.subject}\n\n${tpl.body}`); flash("Šablon kopiran"); }}>kopiraj šablon</button></div>
      <p class="note">Adrese označene kao <i>pretpostavljeno</i> slijede obrazac fakulteta ali nisu pronađene na službenoj stranici, pa nisu uključene u „email svima“ dok to ne označite.</p>
    </Modal>
  );
}
